import { Injectable } from '@angular/core';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { API_URL } from 'common/constants/sm-constants';
import { SystemService } from 'common/services/core-services/system.service';
import { GridParams, GridPostParams } from 'common/models/utility-models/list-utility.model';
import { GridDataService } from '../../base-data-services/grid-data.service';
import { ReportsNavigationModel } from 'common/models/page-models/reports/reports-navigation/report-navigation-data-model';
import { ReportsNavigationListingModel, ReportsNavigationPostParams } from 'common/models/page-models/reports/reports-navigation/report-navigation-grid-model';


@Injectable({
    providedIn: 'root'
})
export class ReportsNavigationDataService extends GridDataService<ReportsNavigationListingModel, ReportsNavigationModel> {
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.getReportTypeList, http, ss);
    }

    createInstance(): ReportsNavigationListingModel {
        return new ReportsNavigationListingModel();
    }

    getDeleteUrl() {
        return '';
    }

    override getGridParams(param): GridPostParams {
        return new ReportsNavigationPostParams();
    }
}
